export enum ReportFileFormat {
  XLSX = 'xlsx',
  ZIP = 'zip',
  DOCX = 'docx'
}


export type ReportGenerateParams = {
  reportID: string
  format: ReportFileFormat
}

export type GenerateFileResult = string
